module.exports = __webpack_public_path__ + "media/Text_center_high.2205b6be.mp4";